import { SubPageSectionHeading, BridgeCard } from "../../components";
import { generalIcons, redirections } from "../../utils/constants";

function ChooseBridge() {
  return (
    <section className="relative py-6 lg:py-12">
      <div className="w-full flex items-center justify-center">
        <div className="max-w-[879px] flex flex-col items-center justify-center text-center  gap-2">
          <SubPageSectionHeading className="w-full max-w-[763px] text-[clamp(1.75rem,5vw,2.5rem)] leading-[100%] font-[700] tracking-[-0.05em] uppercase font- gradient-text bg-left-bottom bg-textGd overflow-hidden text-ellipsis text-black">
            Choose a Bridge
          </SubPageSectionHeading>
          <p className="text-gunMetal text-[16px]/[24px]  font-medium font-serif -tracking-[1.1px] ">
            Multiple bridges are supporting Vanar Chain
          </p>
        </div>
      </div>
      <div className="grid lg:grid-cols-3 gap-4 mt-10">
        <BridgeCard
          bridgeImge={generalIcons.nitroImg}
          bridgeTitle="Nitro Bridge"
          content="The Router Nitro Bridge enables fast, low-cost cross-chain transfers, boosting Vanar's scalability and ecosystem connectivity."
          active={true}
          url={redirections.BRIDGE}
          urlName="Bridge Now"
        />
        <BridgeCard
          bridgeImge={generalIcons.nitroImg}
          bridgeTitle="Nitro Bridge"
          content="The Router Nitro Bridge enables fast, low-cost cross-chain transfers, boosting Vanar's scalability and ecosystem connectivity."
          url={redirections.BRIDGE}
          urlName="Bridge Now"
        />
        <BridgeCard
          bridgeImge={generalIcons.nitroImg}
          bridgeTitle="Nitro Bridge"
          content="The Router Nitro Bridge enables fast, low-cost cross-chain transfers, boosting Vanar's scalability and ecosystem connectivity."
          url={redirections.BRIDGE}
          urlName="Bridge Now"
        />
        {/* <div className="col-span-1">
          <div className=" w-full min-h-[268px] md:min-h-[480px] benefitcard group relative flex flex-col h-full items-start gap-3 lg:px-[20px] py-[15px] lg:min-h-[268px] bg-white hoverCardTop p-6 lg:p-8 duration-300 ">
            <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="flex flex-col justify-between h-full relative z-[1]">
              <div className="flex justify-between w-full">
                <div className="flex items-center gap-4 laptop:gap-5">
                  <div className="flex items-center justify-center p-[13px] laptop:p-[17px] w-[80px] h-[80px] laptop:w-[70px] laptop:h-[70px]  rounded-3xl bg-[#010101]">
                    {generalIcons.nitroImg}
                  </div>
                  <div className="flex flex-col gap-3 laptop:gap-[14px]">
                    <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-gunMetal font-sans"></h4>
                    <div className="flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-md h-9 max-w-fit  bg-accordientGD">
                      Active
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 *:w-full *:h-full">
                  {generalIcons.arrowCard}
                </div>
              </div>
              <p className="text-gunMetal  text-sm md:text-base leading-5 md:leading-6 font-normal -tracking-[0.72px]"></p>
              <a
                href={redirections.BRIDGE}
                target="_blank"
                rel="noreferrer"
                className="text-green inline-flex gap-2 items-center  py-[0px] md:py-0 px-0 leading-none w-full text-[16px] font-semibold font-serif *:hover:ml-1 *:duration-300 "
              >
                <span className="size-6 *:size-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14.5143 6L20 12L14.5143 18M19.0857 12L4 12"
                      stroke="#282B35"
                      strokeWidth="1.5"
                      strokeLinejoin="bevel"
                    />
                  </svg>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-span-1">
          <div className=" w-full min-h-[268px] md:min-h-[480px] benefitcard group relative flex flex-col h-full items-start gap-3 lg:px-[20px] py-[15px] lg:min-h-[268px] bg-white hoverCardTop p-6 lg:p-8 duration-300 ">
            <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="flex flex-col justify-between h-full relative z-[1]">
              <div className="flex justify-between w-full">
                <div className="flex items-center gap-4 laptop:gap-5">
                  <div className="flex items-center justify-center p-[13px] laptop:p-[17px] w-[80px] h-[80px] laptop:w-[70px] laptop:h-[70px]  rounded-3xl bg-[#010101]">
                    {generalIcons.nitroImg}
                  </div>
                  <div className="flex flex-col gap-3 laptop:gap-[14px]">
                    <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-gunMetal font-sans">
                      Nitro Bridge
                    </h4>
                    <div className="flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-md h-9 max-w-fit  bg-accordientGD">
                      Active
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 *:w-full *:h-full">
                  {generalIcons.arrowCard}
                </div>
              </div>
              <p className="text-gunMetal  text-sm md:text-base leading-5 md:leading-6 font-normal -tracking-[0.72px]">
                The Router Nitro Bridge enables fast, low-cost cross-chain
                transfers, boosting Vanar's scalability and ecosystem
                connectivity.
              </p>
              <a
                href={redirections.BRIDGE}
                target="_blank"
                rel="noreferrer"
                className="text-green inline-flex gap-2 items-center  py-[0px] md:py-0 px-0 leading-none w-full text-[16px] font-semibold font-serif *:hover:ml-1 *:duration-300 "
              >
                Bridge Now
                <span className="size-6 *:size-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14.5143 6L20 12L14.5143 18M19.0857 12L4 12"
                      stroke="#282B35"
                      strokeWidth="1.5"
                      strokeLinejoin="bevel"
                    />
                  </svg>
                </span>
              </a>
            </div>
            <div className="absolute top-0 left-0 z-[2] w-full h-full flex items-center justify-center bg-blurBG hoverCardTop ">
            </div>
          </div>
        </div>*/}
        {/* <div className="col-span-1">
          <div className=" w-full min-h-[268px] md:min-h-[480px] benefitcard group relative flex flex-col h-full items-start gap-3 lg:px-[20px] py-[15px] lg:min-h-[268px] bg-white hoverCardTop p-6 lg:p-8 duration-300 ">
            <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="flex flex-col justify-between h-full relative z-[1]">
              <div className="flex justify-between w-full">
                <div className="flex items-center gap-4 laptop:gap-5">
                  <div className="flex items-center justify-center p-[13px] laptop:p-[17px] w-[80px] h-[80px] laptop:w-[70px] laptop:h-[70px] rounded-3xl bg-[#010101]">
                    {generalIcons.nitroImg}
                  </div>
                  <div className="flex flex-col gap-3 laptop:gap-[14px]">
                    <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-gunMetal font-sans">
                      Nitro Bridge
                    </h4>
                    <div className="flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-md h-9 max-w-fit  bg-accordientGD">
                      Active
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 *:w-full *:h-full">
                  {generalIcons.arrowCard}
                </div>
              </div>
              <p className="text-gunMetal  text-sm md:text-base leading-5 md:leading-6 font-normal -tracking-[0.72px]">
                The Router Nitro Bridge enables fast, low-cost cross-chain
                transfers, boosting Vanar's scalability and ecosystem
                connectivity.
              </p>
              <a
                href={redirections.BRIDGE}
                target="_blank"
                rel="noreferrer"
                className="text-green inline-flex gap-2 items-center  py-[0px] md:py-0 px-0 leading-none w-full text-[16px] font-semibold font-serif *:hover:ml-1 *:duration-300 "
              >
                Bridge Now
                <span className="size-6 *:size-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14.5143 6L20 12L14.5143 18M19.0857 12L4 12"
                      stroke="#282B35"
                      strokeWidth="1.5"
                      strokeLinejoin="bevel"
                    />
                  </svg>
                </span>
              </a>
            </div>
            <div className="absolute top-0 left-0 z-[2] w-full h-full flex items-center justify-center bg-black/[0.40] backdrop-blur-[20px]">
              <div className="flex items-center justify-center text-xl leading-none font-semibold -tracking-[0.8px] px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-full max-w-fit">
                Coming soon
              </div>
            </div>
          </div>
        </div>  */}
      </div>
    </section>
  );
}

export default ChooseBridge;
